import { Reveal } from "@/components/Reveal";
import { SectionHeading } from "@/components/SectionHeading";
import MeterForm from "@/components/MeterForm";
import { Droplets, Snowflake, Wrench, ReceiptText, Phone } from "lucide-react";

const INFO_CARDS = [
  {
    icon: Droplets,
    title: "Info für neue Pächter",
    points: [
      "Werfen Sie gleich nach Ihrer Ankunft einen Blick in Ihre Wassergrube und notieren Sie Zählerstand und Zählernummer (am Rand des Zählers).",
      "Prüfen Sie die Absperrventile durch Auf- und Zudrehen.",
      "Melden Sie Zählerstand und Zählernummer an den Wasserbeauftragten – z. B. über das Formular unten oder per Mail an Wasser@kga-schoenwald.de.",
      "Wartung der Wassergrube sowie Leitungen und Armaturen auf Ihrem Grundstück liegen in Ihrer Verantwortung.",
    ],
  },
  {
    icon: Snowflake,
    title: "Winterfest machen",
    points: [
      "Kontrollieren Sie Ihren Zählerstand mehrmals im Jahr – ein sprungartig erhöhter Stand kann auf einen Leitungsdefekt hinweisen.",
      "Vor dem Winter: Hauptschieber zudrehen, Leitung entleeren und die Wassergrube vor Frost schützen.",
      "Wasserzähler und Plomben dürfen nur vom Wasserbeauftragten getauscht werden.",
      "Frostschäden am Zähler bitte melden – der Austausch ist kostenpflichtig.",
    ],
  },
  {
    icon: ReceiptText,
    title: "Ein Abwasser – zwei Rechnungen",
    points: [
      "Das Fuhrunternehmen Ihrer Wahl stellt Abpumpen und Abfuhr zum Klärwerk direkt in Rechnung.",
      "Die zweite Rechnung („Abwasser anteilig 30 % vom Frischwasserbezug“) für die Abwasserbehandlung erhalten Sie vom Verein in der Jahresabrechnung.",
      "Der Verein hat einen Vertrag mit den Berliner Wasserbetrieben – als Pächter profitieren Sie über die Wassergemeinschaft davon.",
    ],
  },
];

export default function Wasser() {
  return (
    <section id="wasser" className="py-16 md:py-28" data-testid="wasser-section">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <SectionHeading
          number="05"
          eyebrow="Wasser & Abwasser"
          title="Alles rund um die Wasserversorgung"
          text="Wasserbeauftragter ist Herr Axel Birker – zuständig für die reibungslose Versorgung vom Hauptwasserzähler der Berliner Wasserbetriebe bis zu Ihrem Wasserzähler. Die Telefonnummer finden Sie in den Schaukästen der Anlage."
        />
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          {INFO_CARDS.map((card, i) => (
            <Reveal key={card.title} delay={i * 0.1}>
              <div className="h-full rounded-2xl border border-[#D8D3C5] bg-white p-7 transition-all duration-300 hover:-translate-y-1 hover:border-[#5A826B]" data-testid={`wasser-card-${i}`}>
                <span className="flex h-12 w-12 items-center justify-center rounded-full bg-[#E2ECE5] text-[#1A382B]">
                  <card.icon size={21} strokeWidth={1.8} />
                </span>
                <h3 className="mt-5 font-display text-xl sm:text-2xl font-semibold text-[#1A382B]">{card.title}</h3>
                <ul className="mt-4 space-y-3 text-sm sm:text-base leading-relaxed text-[#47544A]">
                  {card.points.map((p, j) => (
                    <li key={j} className="flex gap-2.5">
                      <span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-[#C85A32]" />
                      {p}
                    </li>
                  ))}
                </ul>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.1} className="mt-6">
          <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4 rounded-2xl border border-[#D8D3C5] bg-[#E2ECE5] p-6" data-testid="abwasser-firma-card">
            <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-[#1A382B] text-[#F8F7F2]">
              <Wrench size={20} strokeWidth={1.8} />
            </span>
            <div className="flex-1">
              <p className="font-jbm text-[10px] tracking-[0.25em] uppercase text-[#5A826B]">Bewährte Firma für Grubenentleerung</p>
              <p className="font-display text-xl font-semibold text-[#1A382B]">Olaf Stöber Grubenentleerung · Berlin-Rosenthal</p>
              <p className="text-sm text-[#47544A]">Bürozeiten: Mo.–Fr. 8:00 – 17:00 Uhr</p>
            </div>
            <a href="tel:+49309121158" data-testid="abwasser-phone-link" className="inline-flex items-center gap-2 rounded-full bg-[#1A382B] px-5 py-2.5 text-sm font-semibold text-[#F8F7F2] transition-colors duration-300 hover:bg-[#C85A32]">
              <Phone size={15} /> 030 912 11 58
            </a>
          </div>
        </Reveal>

        <Reveal delay={0.15} className="mt-10">
          <MeterForm />
        </Reveal>
      </div>
    </section>
  );
}
